import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hasAgreedTosSelector } from '../../selectors/authentication';
import Modal from '../../components/helpers/Modal';
import Checkbox from '../../components/forms/Checkbox';
import { PRIVACY_PATH, TCO_PATH } from '../../constants/routes';
import Loading from '../../components/helpers/Loading';
import { acceptTos } from '../../actions/authentication';

class PrivacyModal extends Component {
    state = { submitting: false, checked: false };
    _check = () => {
        this.setState({ submitting: true, checked: true });
        this.props.acceptTos();
    };
    render() {
        return (
            <Modal className="ckp-modal-min-height" noClose={true} open={!this.props.hasAgreedTos}>
                <h4 className="ckp-ts-h4 u-text-center ckp-modal-title">
                    Please agree with our privacy policy and terms & conditions.
                </h4>
                {this.state.submitting ? (
                    <Loading />
                ) : (
                    <Checkbox
                        onChange={this._check}
                        checked={this.state.checked}
                        label={
                            <span>
                                I agree with the{' '}
                                <a href={PRIVACY_PATH} target="_blank">
                                    privacy policy
                                </a>{' '}
                                and{' '}
                                <a href={TCO_PATH} target="_blank">
                                    terms & conditions
                                </a>
                            </span>
                        }
                    />
                )}
            </Modal>
        );
    }
}

const mapStateToProps = (state) => ({ hasAgreedTos: hasAgreedTosSelector(state) });

const mapDispatchToProps = (dispatch) => bindActionCreators({ acceptTos }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyModal);



// WEBPACK FOOTER //
// ./src/containers/authentication/PrivacyModal.js